const ja = {
	uploadSuccess: 'アップロード成功',
	uploadTitle: '定款をアップロードする',
	sizeText: 'JPG/PNG/PDF をサポート、各ファイルは 5M を超えることはできません',
	upload: 'ファイルを選択',
	cashAccount: '出金口座',
	currentzAccount: '送金口座',
	currentzAccountText: '送金口座が申請されていません',
	currentzAccountText1: '配信アカウントを申請しました',
	descriptionOfWithdrawals: 'バーチャル口座出金ガイド',
	addbankAccount: '銀行口座追加',
	applyforVirtualAccount: 'バーチャル口座申請',
	applyCurrentz: '配信口座申請',
	applyCurrentzTip: '流通口座は、PingPong 流通プラットフォームの多通貨口座であり、サプライヤーへの支払いなど、現金以外の目的に使用できます。 「確認」をクリックすると、分配口座を開設することに同意したことになります。',
	virtualName: 'バーチャルアカウント名',
	defaultNameTip: 'アカウント名はピンポン収集プラットフォームに同期され、対応する関係が形成されます。入力しない場合は、システムのデフォルト名が使用されます。',
	virtualCurrency: 'バーチャルアカウント通貨',
	currencyTip: 'この仮想アカウントでサポートされている通貨を選択してください。複数の通貨を選択できます。',
	addCurrency: '通貨を追加',
	delete: '出金口座を削除する',
	deleteAccountTip: '現在の口座に送金されているお金が入金されます。このアカウントを削除すると、お金は元のアカウントに入金されます。',
	deleteSureTip: 'この引き出し口座を削除してもよろしいですか?',
	association: 'EUR/GBP/PLN 通貨でバーチャル口座を開設する必要がある場合は、最初に会社の定款をアップロードしてください。',
	return: '戻る',
	buttonDelete: '削除',
	cancel: 'キャンセル',
	goInput: 'アップロード',
	inReview: '審査中',
	reviewFailed: 'レビューに失敗しました',
	reviewPending: '審査中',
	modifyBank: '銀行口座を変更する',
	accountInfo: 'アカウント情報',
	comfirm: '確認する',
	currency: '口座通貨',
	bankName: '銀行名',
	cardNo: '口座番号',
	iban: 'IBAN',
	swiftCode: 'SWIFTコード',
	bankCode: '銀行コード',
	bankCountry: '銀行所在国 / 地域',
	reservedPhoneNo: '電話番号',
	virtualAccountName: '振込先口座',
	virtualSuccess: 'バーチャルアカウントが正常に作成されました!',
	exceed: '仮想アカウントの数は Web サイトの数を超えることはできません',
	created: 'バーチャルアカウントが正常に作成されました',
	atleast: '少なくとも 1 つの通貨を選択してください',
	awd: {
		warmTips: '親切なヒント',
		notSet: '出金口座が選択されていません',
		toSet: '設定に移動',
		skipSet: 'まだ設定していない場合、この通貨は自動的に引き出すことができません。',
		autoWithdrawal: '自動引き落とし機能',
		autoWithdrawalSet: '自動引き落とし設定',
		topTip: '自動引き出し機能をオンにすると、指定した時間にアカウント内の引き出し可能なすべての金額に対する引き出しリクエストが自動的に開始されます。',
		periodicity: '自動引き出しサイクル',
		minAmount: '最低出金額',
		setMinAmount: '最低出金額を設定する',
		limitAmount: '最低出金額は100ドル以上である必要があります',
		setMinTips: '出金金額を設定後、口座内の金額がその金額以上になると「自動出金サイクル」で自動出金が開始されます。アカウント通貨が米ドルでない場合は、米ドルに換算され、出金額と比較されます。出金額の設定はすべてのアカウントに適用されます。',
		enabled: '有効',
		unenabled: '有効になっていません',
		unconfigured: '未設定',
		detail: '詳細',
		set: '設定',
		currency: '通貨',
		withdrawalTo: 'お金を自動的に引き出して、',
		warnTitle: '自動引き落としの手順',
		confirmSet: 'すでに気づいています',
		edit: '自動出金設定を編集する',
		save: '設定を保存する',
		cancel: '変更をキャンセルする',
		agree: '読んで同意します',
		pleaseRead: '上記の指示を読んで同意してください',
		close: '自動引き出しを無効にする理由:',
		modifyAccountTip: 'この口座は自動引き落としに設定されています。このアカウントを変更すると、対応する通貨を自動的に引き出すことができなくなります。',
		deleteAccountTip: 'この口座は自動引き落としに設定されています。このアカウントを削除すると、対応する通貨を自動的に引き出すことができなくなります。',
		tips: [['1. お客様は、PingPong Checkout 自動引き出しサービスの申し込みおよび使用のプロセス中に、必要なすべての関連情報をタイムリーに当社に提供することを約束し、提供された情報の正確性、合法性、信頼性、完全性および有効性について全責任を負うものとします。そうでない場合、PingPong に生じたすべての損失はお客様が負担しなければなりません。'], ['2. 自動出金サービスのルール：', ['(1) マーチャント バックエンド アカウント センターの引き出しアカウントを通じて自動引き出しサービスを有効にすることができます。アクティブ化後、PingPong は設定したルールに従って自動引き出しプロセスを開始します。', '(2) 自動引き出しサービスは、正味総額の全額引き出しのみをサポートします。 PingPong Checkout アカウントの特定の通貨での単一の GROUP アカウントの資金にマイナスの値がある場合は、その通貨の正味総額または PingPong Checkout アカウントの正味総額 (いずれか低い方) が表示されます。資金引き出しの順序は、販売者のバックエンドのグループ アカウントの上から下への順序に基づきます。', '(3) 出金可能額が対応する自動出金サービス手数料に満たない場合、自動出金は行われません。', '(4) 出金金額を設定後、口座残高がその金額以上になると「自動出金サイクル」で自動引落が開始されます。アカウント通貨が米ドルでない場合は、米ドルに換算され、出金額と比較されます。出金額の設定はすべてのアカウントに適用されます。', '(5) 自動引き出しのトリガー時間は、営業日の 0:00 UTC+0 (つまり、北京時間の 8:00) です。具体的なトリガー時間は、設定した自動引き出しサービスの頻度によって異なります。ヨーロッパ、ルクセンブルク、または中国に祝日がある場合、処理は休日後の最初の営業日に延期されます。', '(6) 自動出金がトリガーされた後、PingPong は内部コンプライアンス ポリシーおよびリスク管理要件に従って自動出金申請を審査します。お客様の自動出金申請がピンポンのコンプライアンスポリシーまたはリスク管理要件に準拠していない場合、ピンポンは自動出金申請を拒否する権利を有します。', '(7) 連続 14 暦日以内に自動出金申請が 3 回以上 (3 回を含む) 拒否された場合、PingPong は自動的に自動出金機能をオフにします。閉店後はリセットして自動引き落とし機能をオンにすることができます。', '(8) PingPong は、お客様の PingPong Checkout アカウントの取引および関連業務を審査する権利を有します。取引または運用にリスクがある場合、PingPong は自動引き出し機能を閉鎖する権利を有します。この場合、自動引き出し機能を再度有効にする権利はありません。']], ['3. PingPong Checkout 自動引き出しサービス手数料は通貨に応じて課金されます。特定の課金ルールは、PingPong とお客様の間で別途合意されたルールに従うものとします。'], ['4. 自動現金引き出しサービスを有効にした後、サービスの使用を停止したい場合は、マーチャント バックエンド - アカウント センター - 現金引き出しアカウントの操作で、速やかに自動現金引き出しサービスをオフにしてください。'], ['5. 当社は、以下の理由による自動引き出しサービスの遅延、中断、または引き出しの失敗については一切の責任を負いません。(i) お客様の理由（提供した不正確な情報、引き出し口座を提供しなかった、提供した引き出し口座への入金が拒否されたなどを含みますがこれらに限定されません）による。 (ii) サードパーティの理由（サードパーティのシステム障害、ポリシーの変更などを含みますが、これらに限定されません）。 (iii) ネットワーク障害、不可抗力、その他の要因。'], ['6. PingPong Checkout 自動引き出しサービスの有効化を確認した後、お客様は、(i) お客様が当社に提供したすべての情報を取得して使用することを当社に許可すること、および (ii) この自動引き出しサービスを促進するために必要な情報 (引き出し口座を含むがこれに限定されない) をサービスプロバイダーに提供することを許可することに同意するものとします。'], ['7. オンライン ページを通じてクリックして確認することにより、お客様は、本通知のすべての利用規約、および公開された、または今後公開される可能性のある本通知に関連するさまざまな規則、ページ表示、操作手順、発表または通知 (以下、総称して「規則」といいます) に同意することに同意するものとし、PingPong は、いつでも即時有効に本通知および規則の内容を変更する権利を有します。本通知の変更後も引き続きPingPong Checkout自動出金サービスをご利用いただく場合、かかる変更に同意したものとみなされます。上記の条項に同意しない場合は、PingPong Checkout の自動引き出しを申請したり、使用を継続したりすることはできません。']]
	},
	accountCenter: {
		bankAccountName: '受取人のアカウント名',
		accountCenterTitle: 'アカウントセンター',
		clientId: 'お客様番号',
		accountInformation: 'アカウント情報',
		emailAddress: '電子メールアドレス',
		phoneNumber: '電話番号',
		identityVerification: '実名認証',
		remittanceAccount: '振込先口座',
		accountOpenArea: '口座開設銀行住所',
		select: '選択してください',
		selectShort: '選択してください',
		hongkong: '香港、中国',
		mainLand: '中国本土',
		europe: 'ヨーロッパ',
		america: 'アメリカ合衆国',
		singapore: 'シンガポール',
		korea: '韓国',
		japan: '日本',
		uk: 'イギリス',
		usd: 'ドル',
		rmb: '人民元',
		eur: 'ユーロ',
		gbp: '英ポンド',
		aud: 'オーストラリアドル',
		hkd: '香港ドル',
		krw: '韓国ウォン',
		sgd: 'シンガポールドル',
		cnh: 'オフショア人民元',
		jpy: '日本円',
		cad: 'カナダドル',
		accountCurrency: '口座通貨',
		companyLegalName: '会社名',
		companyLegalNameInEnglish: '会社名（英語）',
		bankName: '銀行名',
		bankAccountNumber: '口座番号',
		iban: 'IBAN',
		swiftCode: 'SWIFTコード',
		searchSwiftCode: 'Swift コードのクエリ',
		bankBranchName: '支店名',
		bankCode: '銀行コード',
		bankCountry: '銀行の国/地域',
		bankBranchAddress: '口座開設支店住所',
		bankBranchDetailAddress: '支店固有のアドレス',
		phoneNumber2: '電話番号',
		bankAccountEmail: '受取人のメールアドレス',
		shortCardNo: 'Sort Code',
		bankAccountCertificate: '銀行口座開設証明書',
		isVa: 'PingPong の支払い回収にバーチャル アカウントを使用するかどうか',
		yes: 'はい',
		no: 'いいえ',
		registeredPhoneNumber: '携帯電話番号をバインドする',
		verificationCode: 'セキュリティ認証コード',
		getaVerificationCode: '認証コードを取得',
		confirm: 'アカウントの追加を確認してください',
		cancel: 'キャンセル',
		comfirmbtn: '確認',
		resendAfter30s: '後で再送信可能',
		pleaseSelectAccountOpenArea: '銀行カード口座開設地域を選択してください',
		pleaseSelectAccounturrency: '口座開設用の通貨を選択してください',
		pleaseEntrySortCode: 'ソートコードを入力してください',
		pleaseEnterBankName: '銀行名を入力してください',
		pleaseEnterBankAccountNumber: '銀行カード番号を入力してください',
		pleaseEnterRightBankAccountNumber: '銀行カード番号には英語の文字と数字のみが使用できます',
		pleaseEnterIban: 'IBAN を入力してください',
		pleaseEnterRightIban: 'IBAN では英語の文字と数字のみを入力できます',
		pleaseEnterSwiftCode: 'Swiftコードコードを入力してください',
		swiftCodeInvalid: '8 文字または 11 文字の大文字または数字を入力してください。スペースは使用できません',
		pleaseEnterBankBranchName: '支店名をご記入ください',
		pleaseEnterAbaRoutingNumber: 'ACH ルーティング番号を入力してください',
		pleaseEnterBankCode: '銀行コードを入力してください',
		pleaseEnter3DigitsCode: '3桁を入力してください',
		pleaseEnterBankBranchAddress: '支店の具体的な住所を入力してください',
		pleaseEnterVerificationCode: '確認コードを入力してください',
		errorVerificaitonCode: '認証コードエラー',
		invalidVerificationCode: '認証コードが無効です',
		accountAlreadyExists: '収益アカウントはすでに存在します',
		successSubmit: '収益アカウントを正常に追加しました',
		bankChineseName: '中国の銀行名を入力してください',
		bankbranchChineseName: '支店の中国語名を入力してください',
		bankbranchAddressChineseName: '支店の中国の住所を入力してください',
		bankEnName: '英語の銀行名を入力してください',
		bankbranchEnName: '支店名を英語で入力してください',
		bankbranchAddressEnName: '支店の英語の住所を入力してください',
		pleaseEnterBankCountry: '銀行がある国/地域を入力してください',
		pleaseEnterBankOpen: '銀行口座開設証明書を入力してください',
		pleaseEnterBankAccountEmail: '受取人のメールアドレスを入力してください',
		illegalBankAccountEmail: '正しい支払い受取人のメールアドレスを入力してください'
	},
	remittance: {
		remittanceAccount: '振込先口座',
		modifyAccountInfo: 'アカウント情報を変更する',
		failed1st: '支払いアカウント情報が審査に合格しませんでした。',
		failed2nd: 'を修正して再審査のために送信してください。ご質問がございましたら、お気軽にお問い合わせください',
		failed3rd: 'カスタマーサービスにお問い合わせください',
		failedTips: '支払いアカウントが審査に合格しなかった場合は、資金の流れへの影響を避けるために、できるだけ早くカスタマーサービスにご連絡ください。',
		pending: 'あなたの支払いアカウント情報は審査中です。審査に合格したら、出金を開始できます。',
		pending2nd: 'あなたの支払いアカウントは審査中です。レビューが承認されると、資金の自動送金が開始されます。',
		modalTipsWarn1: '現在のアカウントは',
		modalTipsWarn2: '支払われる金額',
		modalTipsWarn3: '元のアカウントに入金されます。これらの資金を新しい支払いアカウントに入金したい場合は、カスタマー サービスまでご連絡ください。',
		confirm: '確認する'
	},
	vaState: {
		normal: '',
		exceed: '仮想アカウントの数は Web サイトの数を超えることはできません',
		warn: 'バーチャルアカウントの申請数が上限に達しました。新しく適用されたバーチャル アカウントは現在、オンショア人民元の外国為替決済における PingPong での支払い回収をサポートしていません。作成を続ける必要がありますか?'
	},
	warningTip: '確認',
	contact: 'お問い合わせ',
	editAccount: '口座情報を変更'
}
export default ja
